import React from 'react';

function Cross(props: { size?: number; color?: string } & React.SVGProps<SVGSVGElement>) {
    return (
        <svg width={props.size} height={props.size} viewBox="0 0 5 6">
            <g fill={props.color} fillRule="evenodd">
                <path d="M4.268.525l.707.707L.732 5.475l-.707-.707z" />
                <path d="M4.975 4.768l-.707.707L.025 1.232.732.525z" />
            </g>
        </svg>
    );
}

export default Cross;
